module.exports = "/assets/09192fe8a7fc401456b2f2570b328d88.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/HG.png
// module id = 2564
// module chunks = 0